const PlusItemsIcon = () => {
    return (
        <svg className={"svg-icon"} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.5 14C11.9853 14 14 11.9853 14 9.5C14 7.01472 11.9853 5 9.5 5C7.01472 5 5 7.01472 5 9.5C5 11.9853 7.01472 14 9.5 14Z"
                stroke="#232B25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M22.5 14C24.9853 14 27 11.9853 27 9.5C27 7.01472 24.9853 5 22.5 5C20.0147 5 18 7.01472 18 9.5C18 11.9853 20.0147 14 22.5 14Z"
                stroke="#232B25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M9.5 27C11.9853 27 14 24.9853 14 22.5C14 20.0147 11.9853 18 9.5 18C7.01472 18 5 20.0147 5 22.5C5 24.9853 7.01472 27 9.5 27Z"
                stroke="#232B25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M22.5 19V26" stroke="#232B25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M26 22.5H19" stroke="#232B25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default PlusItemsIcon